import 'bootstrap/dist/css/bootstrap.min.css';
import 'datatables.net';
import 'datatables.net-buttons';
import 'datatables.net-buttons-dt/css/buttons.dataTables.min.css';
import 'datatables.net-buttons/js/buttons.colVis';
import 'datatables.net-buttons/js/buttons.html5';
import 'datatables.net-buttons/js/buttons.print';
import $ from 'jquery';
import React, { useEffect, useRef, useState } from 'react';
import { baseurl } from '../utility/helper';
import Swal from 'sweetalert2';
import axios from "axios";

const International = () => {
  const roleid = parseInt(sessionStorage.getItem("userroleId"));
  const [international, setInternational] = useState([]);
  const [pendingList, setPendingList] = useState([]);
  const [completedList, setCompletedList] = useState([]);

  const pendingRef   = useRef(null);
  const completedRef = useRef(null);

  const initialChapter = roleid === 2 ? sessionStorage.getItem("userchapterId") || "" : "";
  const [memberstatus, setMemberstatus] = useState([]);
  const [chapterId, setChapterId] = useState(initialChapter);  // for use in fetch

  const fetchInternational = async () => {
    try {
      const token = sessionStorage.getItem("token");
      let url = `${baseurl}/admin/international`;

      if (roleid !== 1) {
        url += `?chapter_id=${chapterId}`;
      }

      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Authorization': `${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const data = await response.json();
      setInternational(data);

      // pending → still actionable; anything else → completed
      setPendingList(data.filter(row => row.request_status === 'pending'));
      setCompletedList(data.filter(row => row.request_status !== 'pending'));
    } catch (error) {
      console.error('Error fetching international:', error);
    }
  };


  useEffect(() => {
    const fetchMemberStatus = async () => {
      try {
        const response = await axios.get(`${baseurl}/admin/members/memberterms`);
        setMemberstatus(response.data || []); 
      } catch (error) {
        console.error("Error fetching memberstatus:", error);
      }
    };

    fetchMemberStatus();
    fetchInternational();
  }, []);

  // ── Shared column/button config so both tables render identically ────────
  const buildColumns = () => ([
    { data: null, title: "Sr.No", className: "text-center" },
    { data: 'membership_no', title: 'Membership No' },
    { data: null, title: 'Name' },
    { data: 'mobile_no', title: 'Mobile No' },
    { data: 'email', title: 'Email' },
    { data: 'reason', title: 'Reason' },
    { data: null, title: 'Action', orderable: false },
  ]);

  const buildColumnDefs = (withActions) => ([
    {
      targets: 0,
      render: (data, type, row, meta) => meta.row + 1,
    },
    {
      targets: 1,
      render: (data, type, row) => {
        if (type !== 'display') return data ?? '';
        const mid = row.member_id ?? row.memberId ?? '';
        return `<center><a href="/admin/EditMember?memberId=${mid}&edit=false" onclick="event.preventDefault(); window.open(this.href, '_blank');">${data ?? ''}</a></center>`;
      },
    },
    {
      targets: 2,
      defaultContent: '',
      render: (data, type, row) => `${row.first_name || ''} ${row.last_name || ''}`
    },
    {
      targets: 6,
      render: (data, type, row) => {
        if (withActions && row.request_status === 'pending') {
          return `<select class="form-select form-select-sm transfer-action-dd" data-id="${row.international_transfer_candidate_id}" style="min-width:130px">
                    <option value="">Select</option>
                    <option value="approved">Approve</option>
                    <option value="rejected">Reject</option>
                  </select>`;
        }
        return `<span class="badge bg-secondary">${row.request_status}</span>`;
      },
    }
  ]);

  const renderTable = (tableElement, tableData, withActions) => {
    if (!tableElement) return;

    if ($.fn.DataTable.isDataTable(tableElement)) {
      const table = $(tableElement).DataTable();
      table.clear();
      table.rows.add(tableData);
      table.draw();
      return;
    }

    $(tableElement).DataTable({
      dom: 'Blfrtip',
      pageLength: 25,
      lengthMenu: [[10, 25, 50, 100, 250, 500, -1], [10, 25, 50, 100, 250, 500, "All"]],
      buttons: [
        { extend: 'copyHtml5',  className: 'btn btn-primary dttable', exportOptions: { columns: ':visible' } },
        { extend: 'excelHtml5', className: 'btn btn-primary dttable', exportOptions: { columns: ':visible' } },
        { extend: 'csvHtml5',   className: 'btn btn-primary dttable', exportOptions: { columns: ':visible' } },
        { extend: 'pdfHtml5',   className: 'btn btn-primary dttable', exportOptions: { columns: ':visible' } },
        { extend: 'print',      className: 'btn btn-primary dttable', exportOptions: { columns: ':visible' } },
      ],
      data: tableData,
      columns: buildColumns(),
      columnDefs: buildColumnDefs(withActions),
      initComplete: function () {
        $('.dt-length select').addClass('form-select form-select-sm');
      }
    });
  };

  useEffect(() => {
    renderTable(pendingRef.current,   pendingList,   true);
    renderTable(completedRef.current, completedList, false);

    $(document).off('change', '.transfer-action-dd').on('change', '.transfer-action-dd', async function (e) {
      e.preventDefault();
      const id = $(this).data('id');
      const status = $(this).val();
      const $dd = $(this);
      if (!status) return;
      // Find the selected chapter from the corresponding dropdown in the same row
      const $row = $(this).closest('tr');
      const selectedstatusId = $row.find('.select-chapter').val();
      // if (!selectedstatusId) {
      //   Swal.fire('Select Chapter', 'Please select a chapter before proceeding.', 'warning');
      //   return;
      // }

      const result = await Swal.fire({
        title: 'Are you sure?',
        text: `Do you want to ${status.toLowerCase()} this member transfer?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: `Yes, ${status}!`,
        cancelButtonText: 'Cancel',
      });

      if (!result.isConfirmed) { $dd.val(''); return; }
      if (result.isConfirmed) {
        try {
          const token = sessionStorage.getItem("token");
          await $.ajax({
            url: `${baseurl}/admin/international/${id}`,
            type: 'PUT',
            headers: {
              Authorization: `${token}`,
              'Content-Type': 'application/json',
            },
            data: JSON.stringify({
              status: status,
              status_id: selectedstatusId, // send selected chapter
            }),
          });

          Swal.fire(
            `${status.charAt(0).toUpperCase() + status.slice(1)}!`,
            `Member transfer ${status.toLowerCase()} successfully.`,
            'success'
          );

          fetchInternational(); // Refresh both tables
        } catch (error) {
          console.error(`Error updating status to ${status}:`, error);
          Swal.fire('Error', 'Error while updating status.', 'error');
        }
      }
    });

    return () => {
      if (pendingRef.current && $.fn.DataTable.isDataTable(pendingRef.current)) {
        $(pendingRef.current).DataTable().destroy();
      }
      if (completedRef.current && $.fn.DataTable.isDataTable(completedRef.current)) {
        $(completedRef.current).DataTable().destroy();
      }
    };
  }, [pendingList, completedList]);

  return (
    <div className="content container-fluid">
      <center><h1>International List</h1></center>

      <div className="container mt-4">
        <div className="profile-section">
          <div className="list mb-4" style={{ overflow: "auto" }}>
            <div className="row">
              <center><h4><b>Pending International</b></h4></center>
              <div className="col-12">
                <table ref={pendingRef} className="table table-striped table-bordered" style={{ width: '100%' }}></table>
              </div>
            </div>
          </div>

          <div className="list" style={{ overflow: "auto" }}>
            <div className="row">
              <center><h4><b>Completed International</b></h4></center>
              <div className="col-12">
                <table ref={completedRef} className="table table-striped table-bordered" style={{ width: '100%' }}></table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

};

export default International;